import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import { CategoryData, RegionData, ThemeData } from '../quantData';
import { Link, useSearchParams } from 'react-router-dom';
import QuantService from '../../../service/quant/Quant';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';

const Quant2 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const index = Number(searchParams.get('index'));
  const selectedRegion = searchParams.get('region');
  const selectedCategory = searchParams.get('category');
  const item = ThemeData[index as number];

  const [p1, setP1] = useState('');
  const [p2, setP2] = useState('');
  const [p3, setP3] = useState('');
  const [p4, setP4] = useState('');

  const updateQuery = (key: string, value: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(key, value);
    setSearchParams(newParams);
  };

  const getCode = (region: string) => {
    const regObj = {
      전국: '',
      서울: '11',
      경기: '41',
      인천: '28',
      부산: '26',
      대전: '30',
      대구: '27',
      울산: '31',
      세종: '36',
      강원: '51',
      충북: '43',
      충남: '44',
      경북: '47',
      경남: '48',
      광주: '29',
      전북: '52',
      전남: '46',
      제주: '50',
    };
    return regObj[region as '전국'];
  };

  const getList = async () => {
    try {
      const result = await QuantService.stats({
        theme: item.name.replace(' ', ''),
        category: (selectedCategory === '전체'
          ? ''
          : selectedCategory) as string,
        ctpCode: getCode(selectedRegion as string),
      });
      if (result.data) {
        result.data.map((el: any, idx: number) => {
          if (idx === 0) {
            setP1(
              (Math.floor(Number(el.profit_rate || 0) * 10) / 10).toFixed(1) ||
                '-',
            );
            setP2(
              (Math.floor(Number(el.loss_rate || 0) * 10) / 10).toFixed(1) ||
                '-',
            );
            setP3('-');
            setP4('-');
          } else if (idx === 1) {
            setP3(
              (Math.floor(Number(el.profit_rate || 0) * 10) / 10).toFixed(1) ||
                '-',
            );
            setP4(
              (Math.floor(Number(el.loss_rate || 0) * 10) / 10).toFixed(1) ||
                '-',
            );
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  const func = async () => {
    if (await UserService.userGrade()) {
      getList();
    } else {
      modalDispatch('MC1');
    }
  };

  const { modalDispatch } = useModal();

  useEffect(() => {
    func();
  }, [selectedRegion, selectedCategory]);

  return (
    <Box gap={8} style={{ background: '#F0F0F0', paddingBottom: '8px' }}>
      <div style={{ padding: '24px 16px', background: '#FFFFFF' }}>
        <Description>
          <Item>
            <TextBox>
              <ItemBox color="#222222" size={14} weight={700}>
                <span>{item.name}</span>
                <ThemeStock>宙</ThemeStock>
              </ItemBox>
              <Text color="#616161" size={12} weight={500}>
                {item.description}
              </Text>
            </TextBox>
            <ItemImage
              src={'/assets/images/quant/' + item.image + '.png'}
              alt=""
              style={{ width: '44px', height: '44px' }}
            />
          </Item>
          <Text_Button to="..">
            <Text color="#008AFF" size={16} weight={700}>
              테마주 변경하기
            </Text>
          </Text_Button>
        </Description>
      </div>
      <Box gap={24} style={{ background: '#FFFFFF' }}>
        <Box style={{ overflowX: 'auto' }}>
          <Row style={{ paddingInline: '16px' }}>
            {RegionData.map((region, index) => (
              <Region_Box
                key={index}
                onClick={() => updateQuery('region', region)}
              >
                <Text
                  color={region === selectedRegion ? '#222222' : '#989BA2'}
                  size={14}
                  weight={region === selectedRegion ? 700 : 500}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {region}
                </Text>
              </Region_Box>
            ))}
          </Row>
          <div style={{ position: 'relative', height: '1px' }}>
            <Line_Selected
              style={{
                left:
                  16 +
                  RegionData.indexOf(selectedRegion as string) * 57.2 +
                  'px',
              }}
            />
          </div>
          <Line />
        </Box>

        <Row
          style={{
            alignItems: 'flex-start',
            overflowX: 'auto',
            paddingInline: '16px',
          }}
          gap={12}
        >
          {CategoryData.map((item, index) => (
            <Category_Item
              key={index}
              onClick={() => updateQuery('category', item.name)}
            >
              <Category_Box selected={selectedCategory === item.name}>
                <img
                  src={'/assets/images/quant/' + item.image + '.svg'}
                  alt=""
                  style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                />
              </Category_Box>
              <Text
                style={{ width: '54px' }}
                color={selectedCategory === item.name ? '#008AFF' : '#616161'}
                size={14}
                weight={selectedCategory === item.name ? 700 : 500}
              >
                {item.name}
              </Text>
            </Category_Item>
          ))}
        </Row>

        <Box gap={8} style={{ alignItems: 'center', padding: '0 16px 40px' }}>
          <Result_Row>
            {[selectedCategory, '예상 수익률'].map(
              //, '최대 손실률'
              (
                item,
                index, //'calc(100%/3)'
              ) => (
                <Row style={{ width: '100%' }}>
                  {index !== 0 && <Column_Line />}
                  <Text
                    color="#222222"
                    size={14}
                    weight={index === 0 ? 700 : 500}
                    key={index}
                    style={{ width: '100%', textAlign: 'center' }}
                  >
                    {item}
                  </Text>
                </Row>
              ),
            )}
          </Result_Row>
          <Result_Row2>
            {['전국', p1 + ' %'].map(
              /// , p2 + ' %'
              (item, index) => (
                <Text
                  color="#222222"
                  size={16}
                  weight={500}
                  key={index}
                  style={{ width: '100%' }} //'240px'
                >
                  {item}
                </Text>
              ),
            )}
          </Result_Row2>
          {selectedRegion !== '전국' && (
            <Result_Row2 on>
              {[selectedRegion, p3 + ' %'].map(
                //, p4 + ' %'
                (item, index) => (
                  <Text
                    color="#222222"
                    size={16}
                    weight={500}
                    key={index}
                    style={{ width: '100%' }} //'240px'
                  >
                    {item}
                  </Text>
                ),
              )}
            </Result_Row2>
          )}
          <Box style={{ paddingTop: '8px', alignItems: 'flex-start' }}>
            <Text color="#37383C9C" size={12} weight={500}>
              * 예상 수익률은 ‘매각 수익률’입니다.
            </Text>
            <Text color="#37383C9C" size={12} weight={500}>
              * 임대 수익률은 추후 제공 예정입니다.
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Quant2;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
  align-items: center;
`;

const ThemeStock = styled.div`
  width: 22;
  height: 17;
  gap: 10px;
  padding-right: 5px;
  padding-left: 5px;
  border-radius: 4px;
  background: linear-gradient(127.44deg, #008aff 0%, #d224ca 100%);
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
`;

const Result_Row2 = styled(Row)<{ on?: boolean }>`
  width: 100%;
  border-radius: 12px;
  background: #ffffff;
  justify-content: space-between;
  align-items: center;
  border: ${(props) => (props.on ? '2px solid #008AFF' : '1px solid #e5e8ea')};
  padding: 24px 0;
`;

const Result_Row = styled(Row)`
  width: 100%;
  border-radius: 12px;
  background: #70737c0d;
  border: 1px solid #e5e8ea;
  justify-content: space-between;
  align-items: center;
`;

const Column_Line = styled.div`
  background: #e5e8ea;
  width: 1px;
  height: 51px;
`;

const Category_Box = styled.div<{ selected: boolean }>`
  padding: 7px;
  border-radius: 8px;
  background: #f7f8fc;
  border: ${(props) =>
    props.selected ? '2px solid #008AFF' : '2px solid #e5e8ea'};
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Category_Item = styled.button`
  gap: 8px;
  width: 54px;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  border: none;
  background: none;
  user-select: none;
  padding: 0px;
`;

const Line_Selected = styled.div`
  width: 65px;
  height: 2px;
  background: #222222;
  top: 0;
  position: absolute;
  transition: 0.5s ease-in-out;
`;

const Line = styled.div`
  width: 1060px;
  height: 1px;
  background: #e1e2e4;
`;

const Region_Box = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  padding: 14px 16px 12px;
  user-select: none;
`;

const TitleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Text_Button = styled(Link)`
  text-decoration: none;
  border: none;
  background: none;
  cursor: pointer;
  padding: 10px 0;
  background: #fafafb;
  border: 1px solid #e5e8ea;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 24px;
  font-weight: 700;
  line-height: 34.8px;
  color: #171e26;
`;

const Description = styled(Box)`
  width: 100%;
  gap: 14px;
  border-radius: 16px;
  background: #eaf2fe;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid #e5e8ea;
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  text-align: center;
  color: ${(props) => props.color};
`;

const ItemBox = styled(Text)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const ItemImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 7px;
`;
